import { useSelector } from 'react-redux';

const AccessControl = ({
  permissionsToOverride = null,
  action,
  children,
  optionalChildren = null,
  additionalPermission = [],
}) => {
  const authReducer = useSelector((state) => state.AuthReducer);
  const { positionPermissions, teamPermissions } =
    authReducer.assignedPermissionsForCurrentUser || {};

  let permissions = [];

  if (permissionsToOverride) {
    // If override is provided → always use it (highest priority)
    permissions = [
      ...new Set([...permissionsToOverride, ...additionalPermission]),
    ];
  } else {
    // Else use position permissions + team permissions from Redux
    permissions = [
      ...(positionPermissions?.map((permission) => permission.codename) || []),
      ...(teamPermissions?.map((permission) => permission.codename) || []),
      ...additionalPermission,
    ];
  }

  // If no override is given AND both positionPermissions and teamPermissions are empty,
  // then allow everything by default (no restrictions applied).
  const noPermissions =
    !permissionsToOverride &&
    (positionPermissions?.length === 0 || !positionPermissions) &&
    (teamPermissions?.length === 0 || !teamPermissions);

  // Final permission check
  const isPermitted = noPermissions || permissions.includes(action);

  // Show content if permitted OR no action is required
  if (isPermitted || !action) {
    return children;
  }
  return optionalChildren;
};

export default AccessControl;
